import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { forgotPasswordSchema, forgotPasswordInput } from '../features/auth/authSchema';
import { useForgotPasswordMutation } from '../api/authAPI';
import FormInput from './FormInput';
import Button from './UI/Button';
import { CardSimple } from './UI/Card';
import { useState } from 'react';

const ForgotPasswordForm = () => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<forgotPasswordInput>({
    resolver: zodResolver(forgotPasswordSchema),
  });

  const onSubmit = async (data: forgotPasswordInput) => {
    try {
      const res = await forgotPassword(data).unwrap();
      setMessage(res.message || "אם כתובת האימייל שהזנת קיימת במערכת, נשלח אליך מייל עם קישור לאיפוס הסיסמה. הקישור תקף למשך שעה אחת מרגע שליחתו.");
      setError('');
    } catch (err:any) {
      setMessage('');
      const errorMessage = (err.data?.message || 'עדכון הסיסמא נכשל') 
      setError(errorMessage);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-100 via-muted to-blue-light p-4"
      dir="rtl"
    >
    <CardSimple className="w-full max-w-lg mx-auto">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

        <h2 className="text-3xl font-bold text-center text-primary">שכחתי סיסמא</h2>

        <FormInput
          label="אימייל"
          type="email"
          placeholder="הכנס אימייל"
          register={{
            ...register('email', {
              onChange: () => {
                setMessage('');
                setError('');
              },
            }),
          }}
          error={errors.email?.message}
          disabled={isLoading}
        />

        <Button type="submit" isLoading={isLoading} fullWidth>
          שלח קישור לאיפוס סיסמה
        </Button>

        {message && <p className="text-success text-center text-sm font-medium">{message}</p>}
        {error && <p className="text-danger text-center text-sm font-medium">{error}</p>}
      </form>
    </CardSimple>
    </div>
  );
};

export default ForgotPasswordForm;
